import React from 'react';
import { useRouter } from 'next/router';
import { GetStaticProps, GetServerSidePropsContext } from 'next';
import { NextSeo } from 'next-seo';
import cookiee from 'cookie';

import SearchBanner from 'src/components/Common/pageBanner';
import ListingsDetails from 'src/components/ListingDetails';
import ListingApi from 'src/api/listings';
import { IListing } from 'src/interface';

type TProps = {
  canonicalUrl: string;
  listing?: IListing;
  related?: IListing[] | null;
};

const ListingWantedDetailPage = ({ canonicalUrl, listing, related }: TProps) => {
  const router = useRouter();

  if (router.isFallback) {
    return <div>Loading...</div>;
  }
  if (listing)
    return (
      <>
        <NextSeo
          canonical={canonicalUrl}
          title={listing.title}
          description={listing.title}
          openGraph={{
            url: canonicalUrl,
            title: listing.title,
            description: listing.title,
            images: [
              {
                url: listing.images[0],
                alt: listing.title,
              },
            ],
          }}
        />
        <SearchBanner />
        <ListingsDetails listing={listing} related={related} isWantedListing />
      </>
    );
  return null;
};
export async function getStaticPaths() {
  return {
    paths: [],
    fallback: true,
  };
}
export const getStaticProps: GetStaticProps = async (ctx) => {
  const { params } = ctx;
  // const { origin } = absoluteUrl(req);
  try {
    // const authCookie = req.headers.cookie;
    // const token =
    //   (authCookie &&
    //     cookiee.parse(authCookie).auth &&
    //     JSON.parse(cookiee.parse(authCookie).auth).token) ||
    //   null;
    const { data } = await ListingApi.fetchWantedListingDetails(params?.listingId || '', '');
    const { listing, related } = data;
    return {
      props: {
        canonicalUrl: `https://rentable.pk/wanted-listing/${params?.listingId}`,
        listing,
        related,
        query: params,
        revalidate: 250,
      },
    };
  } catch (error) {
    console.log(error);
  }
  return {
    props: {
      canonicalUrl: '',
      err: true,
      revalidate: 250,
    },
  };
};
export default ListingWantedDetailPage;
